import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'approval-toolbar',
  templateUrl: './approval-toolbar.component.html',
  styleUrls: ['./approval-toolbar.component.scss']
})

export class ApprovalToolbarComponent {
  @Output() onApprove: EventEmitter<any> = new EventEmitter();
  @Output() onDecline: EventEmitter<any> = new EventEmitter();
  @Output() onReturnApplication: EventEmitter<any> = new EventEmitter();
  @Output() onAmend: EventEmitter<any> = new EventEmitter();

  @Input() public approvers: any;
  @Input() public isUnitRep: boolean;

  public comments: string;
  private amendClicked: boolean = false;

  constructor() {
  }

  approve() {
    this.onApprove.emit(this.comments);
  }

  decline() {
    this.onDecline.emit(this.comments);
  }

  returnApplication() {
    this.onReturnApplication.emit(this.comments);
  }

  amend() {
    let corrections = '';
    if (this.correctionsRequired()) {
      corrections = this.approvers.filter(approver => approver.hasReturned).comments
    }
    this.amendClicked = true;	// manages the visibility of the edit form button
    this.onAmend.emit(corrections);
  }

  isReviewer() {
    return this.approvers.filter(approver => (approver.hasAccess === true)).length > 0;
  }

  hasUcopReviewed() {
    return this.approvers.filter(approver => (approver.role === 'UCOP EHS') && (approver.hasApproved || approver.hasDenied || approver.hasReturned)).length > 0;
  }

  hasEHSReviewed() {
    return this.approvers.filter(approver => (approver.role === 'EHS Liaison') && (approver.hasApproved || approver.hasDenied || approver.hasReturned)).length > 0;
  }

  correctionsRequired() {
    return this.approvers.filter(approver => approver.hasReturned).length > 0;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/approval-toolbar/approval-toolbar.component.ts